export function adaptReceiverBoardResult(result) {
  const rows = Array.isArray(result?.data?.rows) ? result.data.rows : []

  return {
    ...result,
    data: result?.data
      ? {
          ...result.data,
          odds: rows,
        }
      : result?.data,
  }
}

export async function allSettledWithConcurrency(items, concurrency, worker) {
  if (!Array.isArray(items) || items.length === 0) return []

  const width = Math.max(1, Math.min(Number(concurrency) || 1, items.length))
  const results = new Array(items.length)
  let cursor = 0

  const runWorker = async () => {
    while (cursor < items.length) {
      const index = cursor
      cursor += 1

      try {
        results[index] = {
          status: 'fulfilled',
          value: await worker(items[index], index),
        }
      } catch (reason) {
        results[index] = { status: 'rejected', reason }
      }
    }
  }

  await Promise.all(Array.from({ length: width }, () => runWorker()))
  return results
}

export function summarizeReceiverBoardResults(requests, settledResults) {
  const attemptedSports = requests.map(({ sport }) => String(sport || '').toUpperCase())
  const successful = settledResults
    .map((settled, index) => ({ settled, request: requests[index] }))
    .filter(({ settled }) => {
      const result = settled?.status === 'fulfilled' ? settled.value : null
      const rowCount = Number(result?.data?.visible_row_count ?? result?.data?.rows?.length ?? 0)
      return result?.status === 'ok' && rowCount > 0
    })

  const sources = new Set(successful.map(({ settled }) => settled.value.data?.source).filter(Boolean))

  const generatedAt = successful
    .map(({ settled }) => settled.value.data?.generated_at)
    .filter(Boolean)
    .sort((left, right) => new Date(right).getTime() - new Date(left).getTime())[0] || null

  return {
    source: sources.size > 1
      ? 'mixed-receiver-sources'
      : successful[0]?.settled?.value?.data?.source || 'receiver-board-unavailable',
    generatedAt,
    attemptedSports,
    successfulSports: successful.map(({ request }) => String(request.sport || '').toUpperCase()),
    rowCount: successful.reduce(
      (total, { settled }) => total + Number(settled.value.data?.visible_row_count ?? settled.value.data?.rows?.length ?? 0),
      0
    ),
  }
}
